import { useEffect, useState } from "react";
import { Router, useRouter } from "expo-router";
import { useSelector } from "react-redux";
import { RootState } from "@/_store/store";
import { useGetCurrentUserQuery } from "@/_store/currentUser/currentUser.slice";


const Home = () => {
  const router: Router = useRouter();
  const [hasRedirected, setHasRedirected] = useState<boolean>(false);

  const authToken: string | null = useSelector((state: RootState) => state.account?.authToken);
  const { data: currentUser, isLoading: isUserLoading, error } = useGetCurrentUserQuery(undefined, {
    skip: !authToken,
    refetchOnMountOrArgChange: true
  });

  useEffect(() => {
    if (hasRedirected) return;

    if (isUserLoading) return;

    if (!authToken) {
      setTimeout(() => router.replace("/login"), 0);
      return;
    }

    if (authToken && !currentUser && error) {
      setHasRedirected(true);
      router.replace("/login");
      return;
    }

    if (currentUser) {
      setHasRedirected(true);
      const targetRoute = currentUser.accepted_personal_data ? "/general" : "/user-agreement";
      router.replace(targetRoute);
    }
  }, [authToken, currentUser, error, hasRedirected, isUserLoading, router]);

  return null;
};

export default Home;
